import React, { useRef, useEffect } from 'react';
import AlertService from '../../Services/AlertService';

export default function CloudflareCaptchaComponent({ cb }) {

  const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY || "";
  const captchaRef = useRef(null);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile"]'
    );

    if (!existingScript) {
      const script = document.createElement('script');
      // script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;

      script.onload = () => {
        renderTurnstile();
      };

      script.onerror = (error) => {
        AlertService.alert("error", "Captcha script failed to load");
        console.error(error);
      };

      document.body.appendChild(script);
    } else {
      if (window.turnstile) {
        renderTurnstile();
      } else {
        existingScript.addEventListener('load', renderTurnstile);
      }
    }

    function renderTurnstile() {
      if (
        window.turnstile &&
        captchaRef.current &&
        typeof captchaSiteKey === 'string' &&
        captchaSiteKey.length > 0
      ) {
        try {
          if (!captchaRef.current.hasChildNodes()) {
            window.turnstile.render(captchaRef.current, {
              sitekey: captchaSiteKey,
              theme: 'light',
              language: 'en-US',
              callback: (token) => {
                if (cb) cb(token);
              },
            });
          }
        } catch (err) {
          AlertService.alert("error", err);
        }
      }
    }

    return () => {
      if (captchaRef.current) {
        captchaRef.current.innerHTML = '';
      }
    };
  }, [cb, captchaSiteKey]);

  return (
    <div>
      <div ref={captchaRef} className="cf-turnstile" />
    </div>
  );
}
